// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"dd3ffb3f","687":"9b0e60ca"}[chunkId] + ".chunk.css";
};